export class Rect {
    constructor(height, width, x, y, fillColor, fillOpacity, label) {
        this.height = height;
        this.width = width;
        this.x = x || 0;
        this.y = y || 0;
        this.fillColor = fillColor;
        this.fillOpacity = fillOpacity;
        this.label = label;
    }
}
